var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-xs leading-normal",on:{"click":_vm.copy}},[_c('span',{staticClass:"__code"},[_vm._v(_vm._s(_vm.code))]),_vm._v(" "),_c('span',{staticClass:"bg-primary text-white rounded text-xxs px-2 py-1"},[_vm._v("複製")])])
}
var staticRenderFns = []

export { render, staticRenderFns }